import React from 'react';
export function IdentitySection() {
  return <section className="w-full bg-gray-50" aria-label="Para quién es" data-id="element-106">
      <div className="max-w-3xl mx-auto px-5 py-16 md:py-24" data-id="element-107">
        <div className="max-w-2xl mx-auto" data-id="element-108">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4A] text-center leading-tight mb-8" data-id="element-109">
            "¿Y si yo soy de las que aguanta?"
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-110">
            <p className="text-center text-xl md:text-2xl font-semibold text-[#1B2A4A]" data-id="element-111">
              Entonces eres exactamente la persona para la que está hecha.
            </p>

            <p data-id="element-112">
              Porque este dolor no se "gana" con aguante.{' '}
              <strong className="text-[#1B2A4A]" data-id="element-113">
                Se gana con decisiones.
              </strong>
            </p>

            <p data-id="element-114">La guía no te habla como niña. No te regaña. No te asusta.</p>

            <p className="text-xl md:text-2xl font-bold text-[#C41E3A] text-center py-4" data-id="element-115">
              Te da un sistema.
            </p>
          </div>

          {/* Image */}
          <div className="flex justify-center my-10" data-id="element-116">
            <img src="https://cdn.magicpatterns.com/uploads/t3T3u95TkqcbR5MQy3JgeE/Sos_muela_back.jpg" alt="Mujer consultando la guía SOS Muela en su tablet" className="w-full max-w-sm rounded-2xl shadow-lg" data-id="element-117" />
          </div>

          <p className="text-center text-xl md:text-2xl text-[#1B2A4A] font-semibold italic" data-id="element-118">
            Para mujeres que ya no tienen paciencia para sufrir.
          </p>
        </div>
      </div>
    </section>;
}